import { render, staticRenderFns } from "./SystemDepartmentManage.vue?vue&type=template&id=4c2d53b0&"
import script from "./SystemDepartmentManage.vue?vue&type=script&lang=js&"
export * from "./SystemDepartmentManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports